<template>
  <div class="app-tab">
      <ul class="tab-list">
          <li v-for="item in appTabs" :key="item.id" class="tab" @click="navigateTab(item.id)">
              <div class="micon" :style="`background:url('${item.id === activeId ? item.iconAcitve : item.icon}') center center / contain no-repeat;`"></div>
              <span :class="item.id === activeId ? 'mtxt mactive' : 'mtxt'">{{item.name}}</span>
          </li>
      </ul>
  </div>
</template>

<script>

import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import Cookies from "js-cookie";
import { mapState } from "vuex";
const appTabs = [
    {
        "id": "tab-1",
        "name": "首页", 
        "icon":"https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/home.png",
        "iconAcitve":"https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/home-active.png",
    },
    {
        "id": "tab-2",
        "name": "卖车", 
        "icon":"https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/sell.png",
        "iconAcitve":"https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/sell-active.png",
    },
    {
        "id": "tab-3",
        "name": "我的", 
        "icon":"https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/mine.png",
        "iconAcitve":"https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/mine-active.png",
    }
]

export default {
  components: {

  },
  props: {

  },
  data() {
    return {
        appTabs,
        activeId: ''
    };
  },
  watch: {
      activeId(tabid){
        this.$emit('onTabChange', tabid)
      }
  },
  computed: {
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "userInfo",
    ]),
  },
  methods: {
    navigateTo(url){
        if(window.wx && wx.miniProgram){
            wx.miniProgram.navigateTo({url})
        }
    },
    navigateTab(id){
        this.appTabs = this.appTabs.map(item => {
            item.active = item.id === id
            return item
        })
        this.activeId = id
        Cookies.set('App-Tab', id, { expires: 1 })
    }
  },
  created() {

  },
  mounted() {
    const activeTabId = Cookies.get('App-Tab')
    this.activeId = activeTabId || 'tab-1'
  }
};
</script>
<style lang="scss" scoped>
    .app-tab{
        width: 100%;
        height: 1.2rem;
        background-color: #fff;
        position: fixed;
        bottom: 0px;
        left: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
        .tab-list{
            width: 100%;
            display: flex;
            .tab{
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                padding-top: .2rem;
                .micon{
                    width: .46rem;
                    height: .46rem;
                    background-size: contain;
                }
                .mtxt{
                    padding-top: .1rem;
                    font-size: .2rem;
                    color:#A4A4A4;
                }
                .mactive{
                    color:#0E8AFF;
                }
            }
        }
    }
</style>